import React from 'react';
import { render, screen, cleanup, fireEvent, act } from '@testing-library/react';
import '@testing-library/jest-dom';
import ModalInterviewCancel from './modalInterviewCancel';
import axios from 'axios';

jest.mock('axios');

afterEach(cleanup);

describe('ModalInterviewCancel', () => {
  describe('display interview cancel modal', () => {
    test('renders expected content', () => {
      const id = 1;
      const kanzyano = "A12345";
      const name = "テスト太郎";
      const birthday = "平成01年01月01日";
      const mobile_phone_number = "01234567890";
      const address = "東京都渋谷区渋谷000-00";

      render(<ModalInterviewCancel id={id}
                                   kanzyano={kanzyano}
                                   name={name}
                                   birthday={birthday}
                                   mobile_phone_number={mobile_phone_number}
                                   address={address} />);

      // screen.debug();
    
      expect(screen.getByText("患者番号")).toBeInTheDocument();
      expect(screen.getByText("A12345")).toBeInTheDocument();
      expect(screen.getByText("患者名")).toBeInTheDocument();
      expect(screen.getByText("テスト太郎")).toBeInTheDocument();
      expect(screen.getByText("生年月日")).toBeInTheDocument();
      expect(screen.getByText("平成01年01月01日")).toBeInTheDocument();
      expect(screen.getByText("携帯電話番号")).toBeInTheDocument();
      expect(screen.getByText("01234567890")).toBeInTheDocument();
      expect(screen.getByText("住所")).toBeInTheDocument();
      expect(screen.getByText("東京都渋谷区渋谷000-00")).toBeInTheDocument();
      expect(screen.getByText("紐づけの解除")).toBeInTheDocument();
      expect(screen.getByText("閉じる")).toBeInTheDocument();
    });
  });

  // 紐づけ解除後にモーダルが消えるかどうかを確認
  describe('cancel patient link', () => {
    test('renders expected content', async() => {
      const id = 1;
      const kanzyano = "A12345";
      const name = "テスト太郎";
      const birthday = "平成01年01月01日";
      const mobile_phone_number = "01234567890";
      const address = "東京都渋谷区渋谷000-00";

      const promise = Promise.resolve({
        data: {
          status: "ok"
        }
      });

      (axios.patch as any).mockResolvedValue(promise);
  
      const {container} = render(<ModalInterviewCancel id={id}
                                   kanzyano={kanzyano}
                                   name={name}
                                   birthday={birthday}
                                   mobile_phone_number={mobile_phone_number}
                                   address={address} />);


      await act(() => promise);
      
      const linkCancelButton = screen.getByText('紐づけの解除');
      fireEvent.click(linkCancelButton);
      // クラス名にinがないことでモーダルが消えていることを確認
      expect(await container.querySelector('#modalInterviewCancel')).not.toHaveClass('in');

      // await screen.debug();
    });
  });

});